import {
  isArray, isObject, isUndefined, forEach
} from 'lodash'
import { ENTRYPOINT } from '../config/entrypoint'
import SubmissionError from '../error/SubmissionError'
import store from '@/store'
import router from '@/router'

const MIME_TYPE = 'application/ld+json'

const transformRelationToIri = (payload) => {
  forEach(payload, (value, property) => {
    if (isObject(value) && !isUndefined(value['@id'])) {
      payload[property] = value['@id']
    }

    if (isArray(value)) payload[property] = transformRelationToIri(value)
  })

  return payload
}

const makeParamArray = (key, arr) => arr.map(val => `${key}[]=${val}`).join('&')

export default function (id, options = {}, includeAuth = true, transform = true) {
  if (typeof options.headers === 'undefined') options.headers = new Headers()

  if (options.headers.get('Accept') === null) options.headers.set('Accept', MIME_TYPE)

  if (
    options.body !== 'undefined' &&
    !(options.body instanceof FormData) &&
    options.headers.get('Content-Type') === null
  ) options.headers.set('Content-Type', MIME_TYPE)

  if (includeAuth && store.getters['security/isAuthenticated']) {
    options.headers.set('Authorization', 'Bearer ' + store.getters['security/getField']('token').token)
  }

  if (transform) {
    const payload = options.body && JSON.parse(options.body)
    if (isObject(payload) && payload['@id']) options.body = JSON.stringify(transformRelationToIri(payload))
  }

  if (options.params && Object.keys(options.params).length > 0) {
    const queryString = Object.keys(options.params)
      .map(key =>
        Array.isArray(options.params[key])
          ? makeParamArray(key, options.params[key])
          : `${key}=${options.params[key]}`
      )
      .join('&')
    id = `${id}?${queryString}`
  }

  let action = (new URL(id, ENTRYPOINT)).toString()
  if (action.endsWith('/')) {
    action = action.slice(0, -1)
  }
  return global.fetch(action, options).then((response) => {
    if (response.ok) return response
    if (response.statusText === 'Unauthorized' && store.getters['security/isAuthenticated']) {
      store.commit('security/SECURITY_SET_TOKEN', {})
      router.push({ name: 'Login' })
    }

    return response.json().then((json) => {
      const error = response.statusText
      if (!json.violations) throw Error(error)

      const errors = { _error: error }
      json.violations.map(
        (violation) => (errors[violation.propertyPath] = violation.message)
      )

      throw new SubmissionError(errors)
    })
  })
}
